import { defineStore } from 'pinia';
import type {
  AccordionGroupType,
  WalletDocumentInfosType,
  GroupedWalletDocumentsType
} from '~/types';

export const useWalletDocumentsStore = defineStore('wallet-documents', {
  state: () => ({
    walletDocuments: {} as GroupedWalletDocumentsType,
    documentGroups: [] as Array<AccordionGroupType>,
    selectedDocument: undefined as WalletDocumentInfosType | undefined,
    isPdf: false as boolean,
    selectedType: undefined as string | undefined
  })
});
